import React from 'react'
import _ from 'lodash'

import {formatters} from './parsing.js'

export const ConsoleOutput = ({messages, header, mode}) => {
   let sorted = _.sortByOrder(messages, ['datetime', 'proto/tm.block'], ['asc', 'asc'])

   return (
      <div>
         {header ? header : null}

         {_.map(sorted, (msg, idx) => {
            let res = formatters.serial(msg, mode || 'ascii')

            if (res.error || !res) {
               console.error(res.error, msg)

               return null
            } else {
               return React.cloneElement(res, {key: idx})
            }
         })}
      </div>
   )
}

ConsoleOutput.propTypes = {
   messages: React.PropTypes.array,
   device:   React.PropTypes.object,
   header:   React.PropTypes.string,
   mode:     React.PropTypes.oneOf(['ascii', 'hex', 'decimal', null])
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/device/console/ConsoleOutput.jsx